"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _emotion = require("emotion");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 10px;\n  border-bottom: none;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 10px;\n  display: block;\n  text-align: center;\n  font-family: \"Rubik\", sans-serif;\n  font-weight: 500;\n  font-size: 1em;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var toggleStyle = (0, _emotion.css)(_templateObject());

var Collapsable = function (_React$Component) {
  _inherits(Collapsable, _React$Component);

  function Collapsable(props) {
    var _this;

    _classCallCheck(this, Collapsable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Collapsable).call(this, props));
    _this.state = {
      expanded: false
    };
    _this.onToggle = _this.onToggle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Collapsable, [{
    key: "onToggle",
    value: function onToggle() {
      this.setState({
        expanded: !this.state.expanded
      });
    }
  }, {
    key: "renderToggle",
    value: function renderToggle() {
      var cta = this.state.expanded ? "Less" : "More";
      var arrow = this.state.expanded ? "up" : "down";
      return _react["default"].createElement("a", {
        className: toggleStyle,
        onClick: this.onToggle
      }, cta, _react["default"].createElement("span", {
        style: {
          display: "block"
        },
        className: "fa fa-arrow-".concat(arrow)
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = [];
      var showToggle;
      var toggle;

      _react.Children.forEach(this.props.children, function (child) {
        if (child.props.hidden) {
          showToggle = true;

          if (_this2.state.expanded) {
            children.push(child);
          }
        } else {
          children.push(child);
        }
      });

      if (showToggle) {
        toggle = this.renderToggle();
      }

      return _react["default"].createElement("div", null, children, toggle);
    }
  }]);

  return Collapsable;
}(_react["default"].Component);

var Section = function Section(_ref) {
  var children = _ref.children;
  return children;
};

Collapsable.Section = Section;
var _default = Collapsable;
exports["default"] = _default;